import React from 'react';
import { Button } from 'ui-components/button/button';
import { EmailIcon } from 'components/assets/Icons/IconsMobile';
import { LogoutIcon } from 'components/assets/Icons/Icons';
import { useAuthActions } from 'store/auth/use-auth-actions';
import notFoundImage from 'components/assets/Icons/mobile/not-found.webp';
import notFoundImageFallback from 'components/assets/Icons/mobile/not-found.avif';
import { ImgWithFallback } from 'features/mobile-report/shared/components/img-with-fallback/img-with-fallback';
import { userCookieStorage } from 'core/authentification';

import styles from './app-not-enabled.module.scss';

export const AppNotEnabled = () => {
    const user = userCookieStorage.user;
    const { logout } = useAuthActions();

    const makeMailTo = () => {
        const encodedSubject = encodeURIComponent('Placer - Desktop link');
        const encodedBody = encodeURIComponent(
            'Open the following link on your desktop computer: \n https://analytics.placer.ai/',
        );
        return `mailto:${user?.email}?subject=${encodedSubject}&body=${encodedBody}`;
    };

    return (
        <section className={styles.page}>
            <ImgWithFallback
                className={styles.img}
                src={notFoundImage}
                fallbackSrc={notFoundImageFallback}
                alt="Not Enabled"
            />
            <h1 className={styles.title}>This report is currently not supported on mobile</h1>
            <p className={styles.description}>Please try accessing it via desktop.</p>
            {user && (
                <>
                    <Button
                        className={styles.upgradeButton}
                        onClick={() => (window.location.href = 'mailto:sales@placer.ai')}
                        type="brand-primary-full"
                    >
                        <EmailIcon />
                        Request an upgrade
                    </Button>
                    <Button
                        className={styles.requestButton}
                        onClick={() => (window.location.href = makeMailTo())}
                        type="ghost"
                    >
                        Send desktop Link
                    </Button>
                    <Button className={styles.logoutButton} onClick={logout} type="secondary">
                        <LogoutIcon className={styles.icon} />
                        Log out
                    </Button>
                </>
            )}
        </section>
    );
};
